import { render, staticRenderFns } from "./CardsListForContent.vue?vue&type=template&id=3405c6f3"
import script from "./CardsListForContent.vue?vue&type=script&lang=js"
export * from "./CardsListForContent.vue?vue&type=script&lang=js"
import style0 from "./CardsListForContent.vue?vue&type=style&index=0&id=3405c6f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports